<template>
  <div class="form-messages">
    <div class="required row mx-0">
      <div class="col-12 px-0 text-left">
        <span class="star">*</span>Required to calculate final rate.
        <hr/>
      </div>
    </div>

    <form-alerts :pageData="pageData"></form-alerts>
  </div>
</template>

<script>
import FormAlerts from './FormAlerts';

export default {
  props: ['pageData'],
  components: {
    FormAlerts,
  },
  computed: {
    formMessages() {
      return this.pageData.Error;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/presentational/alerts/FormNotifications.vue?3e01a1d8